export type EmailChatChoice =
  | { type: 'keep' }
  | { type: 'open'; conversationId: string }
  | { type: 'newChat' };

type ChooseEmailChatInput = {
  isFirstEmail: boolean;
  currentConversationId: string | null;
  threadChatId: string | null;
};

export function chooseEmailChat({
  isFirstEmail,
  currentConversationId,
  threadChatId,
}: ChooseEmailChatInput): EmailChatChoice {
  if (isFirstEmail && currentConversationId) return { type: 'keep' };
  if (threadChatId && threadChatId === currentConversationId) {
    return { type: 'keep' };
  }
  if (threadChatId) return { type: 'open', conversationId: threadChatId };
  return isFirstEmail ? { type: 'keep' } : { type: 'newChat' };
}
